import moment from "moment"
import React, { useState } from "react"
import { Col, Container, Row, Table } from "react-bootstrap"
import toast from "react-hot-toast"
import { useNavigate, useParams } from "react-router-dom"
import Navbar from "../../../../Components/Navbar/Navbar"
import TablePagination from "../../../../Components/TableTemplate/Table"
import ElmhurstLogo from "../../../../Assets/Images/elmhurst-initial-logo.png"
import Modal from "antd/es/modal/Modal"
import {
  getInvoice,
  getPaymentHistory,
} from "../../../../Helpers/apiCalls/Purchases/purchaseInvoiceApi"
import { getSupplier } from "../../../../Helpers/apiCalls/suppliersApi"
import {
  dateFormat,
  numberFormat,
  numberFormatInt,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../../Helpers/Utils/Common"
import PIModal from "./PIModal"
import noDataImg from "../../../../Assets/Images/no-data-img.png"
import Footer from "../../../../Components/Footer/Footer"
import "../PurchaseInvoices.css"
import "../../PurchaseOrders/PurchaseOrders.css"

export default function PrintPurchaseInvoice() {
  const { id, shopType } = useParams()
  let navigate = useNavigate()

  const [inactive, setInactive] = useState(true)
  const [printPI, setPrintPI] = useState([])
  const [items, setItems] = useState([])
  const [paymentInfo, setPaymentInfo] = useState([])
  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")

  async function fetchPaymentHistory() {
    const response = await getPaymentHistory(id)

    if (response.data) {
      var history = response.data.data

      var allPayments = history.map((payment) => {
        var info = payment
        info.payment_date = moment(payment.date).format("MMM DD, YYYY")
        info.type = payment.payment_mode
        info.details =
          payment.payment_mode === "check"
            ? payment.payment_mode + " - " + payment.check_no
            : payment.payment_mode === "bank"
            ? payment.payment_mode + " - " + payment.reference_no
            : payment.payment_mode
        info.amount = payment.grand_total
          ? numberFormat(payment.grand_total)
          : "0.00"
        info.amount_applied_to_invoice = payment.amount_applied_to_invoice
          ? numberFormat(payment.amount_applied_to_invoice)
          : "0.00"
        return info
      })
      setPaymentInfo(allPayments)
    } else {
      TokenExpiry(response)
    }
  }

  async function fetchPI() {
    setPrintPI({})
    setItems([])

    const response = await getInvoice(id)

    if (response.error) {
      TokenExpiry(response)
    } else {
      var details = response.data.data[0]
      setFileList(details.receive_attachments)
      if (details.supplier_id !== null) {
        const supplierAPI = await getSupplier(details.supplier_id)
        if (supplierAPI.response) {
          var supplierContact = supplierAPI.response.data[0]
          details.supplier_contact_person =
            supplierContact.contact_person || "(Not indicated)"
          details.supplier_contact_no = supplierContact.phone_no
        }
      }
      setPrintPI(details)
      setItems(details.receive_items)
    }
  }

  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false)
  const handleShowPrintModal = () => setShowPrintModal(true)
  const handleClosePrintModal = () => setShowPrintModal(false)

  async function handlePrintPI() {
    toast.loading("Printing Invoice", { style: toastStyle() })
    handleClosePrintModal()
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }

  function renderTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th></th>
            <th>Item Code</th>
            <th>Item Name</th>
            <th>U o M</th>
            <th>Size</th>
            <th>Quantity</th>
            <th>Discount</th>
            <th>Price/Unit</th>
            <th>Amount</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {items &&
            items?.map((item, index) => {
              return (
                <tr key={index} className="req-table-w-border-bottom">
                  <td className="req-table-w-border-sides">{index + 1}</td>
                  <td className="req-table-w-border-sides">{item.item_code}</td>
                  <td className="req-table-w-border-sides">
                    {item.description
                      ? item.description + " - " + item.item_name
                      : item.item_name}
                  </td>
                  <td className="text-lowercase req-table-w-border-sides">
                    {item.unit}
                  </td>
                  <td className="req-table-w-border-sides">{item.item_size}</td>
                  <td className="req-table-w-border-sides">{item.qty}</td>
                  <td className="req-table-w-border-sides">
                    {numberFormat(item.discount_amount)} (
                    {parseFloat(item.discount_percentage).toFixed(0)}%)
                  </td>
                  <td className="req-table-w-border-sides">
                    {numberFormat(item.price)}
                  </td>
                  <td className="req-table-w-border-sides">
                    {numberFormat(item.amount)}
                  </td>
                  <td className="req-table-w-border-sides">{item.remarks}</td>
                </tr>
              )
            })}
        </tbody>
      </Table>
    )
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  React.useEffect(() => {
    fetchPI()
    fetchPaymentHistory()
  }, [])

  return (
    <div>
      <div className="print-page page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <br />
        <br />
        <div className="print-container px-5 py-2" id="printablediv">
          <div className="print-header-elm d-flex">
            <div className="w-full">
              <div className="print-top d-flex py-1">
                <img src={ElmhurstLogo} className="print-logo-elm" alt="" />
              </div>
              <div className="print-top">
                <h5 className="print-shop-header-elm d-flex print-data justify-content-start">
                  497 D Molave Extension, Lahug, Cebu City
                </h5>
                {/* <h5 className="print-shop-header-elm d-flex justify-content-start">San Roque, Cebu City</h5> */}
              </div>
            </div>
            <div className="purchase-order-number-print-container w-full">
              <h1 className="purchase-order-title-print-elm">
                PURCHASE INVOICE
              </h1>
              <div className="po-date-elm">
                <div className="po-date-and-number">
                  <h5 className="print-shop-header-elm d-flex text-alignment print-data">
                    PO Date: {dateFormat(printPI.purchase_date)}
                  </h5>
                  <h5 className="print-shop-header-elm d-flex text-alignment print-data">
                    {" "}
                    P.O No.: {printPI.po_id}
                  </h5>
                </div>
              </div>
            </div>
          </div>

          <div className="supplier-address-container print-data">
            {/* <h2 className="supplier-title-elm">Supplier</h2> */}
            <p className="print-data fs-6 fw-bold d-flex justify-content-start">
              Supplier: {printPI.supplier_name}
            </p>
            {/* <h5 className="print-shop-header-elm d-flex justify-content-start">
              {printPI.delivery_address}
            </h5> */}
          </div>

          {/* content */}
          <div className="mt-5">
            <Row>
              <Col xs={6} lg={5} md={6} className="split-columns">
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Branch:
                  </Col>
                  <Col xs={5} sm={8} className="print-data">
                    {printPI.branch_name}
                  </Col>
                </div>
                {/* <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Contact Person:
                  </Col>
                  <Col xs={5} sm={8} className="print-data">
                    {printPI.contact_person}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Contact No.:
                  </Col>
                  <Col xs={5} sm={8} className="print-data">
                    {printPI.phone_no}
                  </Col>
                </div> */}
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Forwarder:
                  </Col>
                  <Col xs={5} sm={8} className="print-data">
                    {printPI.forwarder_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Date Received:
                  </Col>
                  <Col xs={6} sm={8} className="print-data">
                    {dateFormat(printPI.receive_date)}
                  </Col>
                </div>
              </Col>

              <Col xs={6} lg={5} md={6} className="split-columns">
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Invoice No.:
                  </Col>
                  <Col xs={6} sm={8} className="print-data">
                    {printPI.invoice_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Waybill No.:
                  </Col>
                  <Col xs={6} sm={8} className="print-data">
                    {printPI.waybill_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    DR No.:
                  </Col>
                  <Col xs={6} sm={8} className="print-data">
                    {printPI.dr_no}
                  </Col>
                </div>
                {/* <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Remarks:
                  </Col>
                  <Col xs={6} sm={8} className="print-data">
                    {printPI.remarks}
                  </Col>
                </div> */}
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    {" "}
                  </Col>
                  <Col xs={6} sm={8} className="print-data"></Col>
                </div>
              </Col>
            </Row>

            <Row className="single-column">
              <Col xs={12}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Branch:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printPI.branch_name}
                  </Col>
                </div>
                {/* <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Contact Person:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printPI.contact_person}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Contact No.:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printPI.phone_no}
                  </Col>
                </div> */}
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Forwarder:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printPI.forwarder_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Date Received:
                  </Col>
                  <Col xs={6} className="print-data">
                    {dateFormat(printPI.receive_date)}
                  </Col>
                </div>
              </Col>

              <Col lg={5} md={6}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Invoice No.:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPI.invoice_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Waybill No.:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPI.waybill_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    DR No.:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPI.dr_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Remarks:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPI.remarks}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    {" "}
                  </Col>
                  <Col xs={6} className="print-data"></Col>
                </div>
              </Col>
            </Row>

            <div className="d-flex mt-1 mb-2 ">
              {/* table */}
              <div className="print-table mt-3">{renderTable()}</div>
            </div>

            <Row className="mt-2">
              <span className="print-footer">
                <strong>Remarks: </strong>
                {printPI.remarks}
              </span>
            </Row>

            {/* <div className="ps-5 ms-5">
              <Row className="mt-2">
                <Col xs={5} lg={9} md={6} className="text-right print-data review-label grand-label-review ">
                  Subtotal 
                </Col>
                <Col xs={6} lg={3} md={3} className="text-right print-data review-label grand-label-review ">
                  PHP {printPI.subtotal ? numberFormat(printPI.subtotal) : "0.00"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col xs={5} lg={9} md={6} className="text-right print-data review-label grand-label-review ">
                  Discount 
                </Col>
                <Col xs={6} lg={3} md={3} className="text-right print-data review-label grand-label-review ">
                  PHP {printPI.discount ? numberFormat(printPI.discount) : "0.00"}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col xs={5} lg={9} md={6} className="text-right print-data review-label grand-label-review ">
                  Deduction Total
                </Col>
                <Col xs={6} lg={3} md={3} className="text-right print-data review-label grand-label-review ">
                  PHP {printPI.deduction_total ? numberFormat(printPI.deduction_total) : "0.00"}
                </Col>
              </Row>
              <Row className="print-grand-total my-2 text-end">
                <Col xs={5} lg={9} md={6} className="print-table-footer-label ">
                  DISCOUNT SUBTOTAL
                </Col>
                <Col xs={6} lg={3} md={3} className="print-table-footer-data text-end ">
                  PHP {printPI.discounted_subtotal ? numberFormat(printPI.discounted_subtotal) : "0.00"}
                </Col>
              </Row>
            </div> */}

            <Row className="print-grand-total my-2 text-end">
              <Col xs={8} lg={9} md={6} className="print-table-footer-label ">
                SUBTOTAL
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="print-table-footer-data text-end"
              >
                {printPI.subtotal ? numberFormat(printPI.subtotal) : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-2 text-end">
              <Col xs={8} lg={9} md={6} className="print-table-footer-label">
                DISCOUNT
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="print-table-footer-data text-end"
              >
                {printPI.discount ? numberFormat(printPI.discount) : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-2 text-end">
              <Col xs={8} lg={9} md={6} className="print-table-footer-label">
                DEDUCTION TOTAL
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="print-table-footer-data text-end"
              >
                {printPI.deduction_total
                  ? numberFormat(printPI.deduction_total)
                  : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-2 text-end">
              <Col xs={8} lg={9} md={6} className="print-table-footer-label">
                DISCOUNT SUBTOTAL
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="print-table-footer-data text-end"
              >
                {printPI.discounted_subtotal
                  ? numberFormat(printPI.discounted_subtotal)
                  : "0.00"}
              </Col>
            </Row>
            {printPI.vat_type === "VAT" && (
              <>
                <Row className="print-grand-total my-2 text-end">
                  <Col
                    xs={8}
                    lg={9}
                    md={6}
                    className="print-table-footer-label"
                  >
                    VAT
                  </Col>
                  <Col
                    xs={2}
                    lg={3}
                    md={3}
                    className="print-table-footer-data text-end"
                  >
                    {printPI.vat ? numberFormat(printPI.vat) : "0.00"}
                  </Col>
                </Row>
                <Row className="print-grand-total my-2 text-end">
                  <Col
                    xs={8}
                    lg={9}
                    md={6}
                    className="print-table-footer-label"
                  >
                    VATABLE SALES
                  </Col>
                  <Col
                    xs={2}
                    lg={3}
                    md={3}
                    className="print-table-footer-data text-end"
                  >
                    {printPI.vatable_sales
                      ? numberFormat(printPI.vatable_sales)
                      : "0.00"}
                  </Col>
                </Row>
                <Row className="print-grand-total my-2 text-end">
                  <Col
                    xs={8}
                    lg={9}
                    md={6}
                    className="print-table-footer-label"
                  >
                    WHT({numberFormatInt(printPI.withholding_percentage)} %)
                  </Col>
                  <Col
                    xs={2}
                    lg={3}
                    md={3}
                    className="print-table-footer-data text-end"
                  >
                    {printPI.withholding_tax
                      ? numberFormat(printPI.withholding_tax)
                      : "0.00"}
                  </Col>
                </Row>
              </>
            )}
            <Row className="print-grand-total my-2 text-end">
              <Col xs={8} lg={9} md={6} className="print-table-footer-label">
                GRAND TOTAL
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="print-table-footer-data text-end"
              >
                {printPI.grandtotal_without_service_fee
                  ? numberFormat(printPI.grandtotal_without_service_fee)
                  : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-2 text-end">
              <Col xs={8} lg={9} md={6} className="print-table-footer-label">
                DELIVERY/SERVICE FEE
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="print-table-footer-data text-end"
              >
                {printPI.service_fee || "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-2 text-end">
              <Col
                xs={8}
                lg={9}
                md={6}
                className="bold print-table-footer-label"
              >
                TOTAL AMOUNT DUE
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="bold print-table-footer-data text-end"
              >
                {printPI.grand_total
                  ? numberFormat(printPI.grand_total)
                  : "0.00"}
              </Col>
            </Row>
            {/* <Row className="print-grand-total mt-3 text-end">
              <Col xs={8} lg={9} md={6} className="bold print-table-footer-label">
                <span className="cheque-pay-to">Cheque pay to ELHMHURST ENTERPRISES COMPANY</span>
              </Col>
            </Row> */}
            <Row className="mt-2">
              {/* <Col xs={6} className="print-sig justify-content-center d-flex">
                <img src={printPI.approved_by_signature} className="print-logo" alt=""/>
              </Col> */}
            </Row>
            <div className="my-5">
              {/* <div className="print-sig justify-content-center d-flex">
                <div className="print-sig text-center gotham">
                  <div className="print-sig justify-content-center d-flex">
                    <img
                      src={printPI.prepared_by_signature}
                      className="print-logo"
                      alt=""
                    />
                  </div>
                  <p className="underline-border print-data">
                    {" "}
                    {printPI.prepared_by}
                  </p>
                  <p className="print-data mt-3"> Prepared by</p>
                </div>
              </div> */}
              <Row className="mt-5 d-flex flex-row align-items-end justify-content-evenly">
                <Col
                  xs={3}
                  className="print-sig justify-content-center d-flex flex-column text-center"
                >
                  <img
                    src={printPI.prepared_by_signature}
                    className="print-logo mx-auto"
                    alt=""
                  />
                  <p className="underline-border print-data w-full p-0">
                    {" "}
                    {printPI.prepared_by}
                  </p>
                  <p className="print-data mt-2"> Prepared by</p>
                </Col>
                <Col
                  xs={3}
                  className="print-sig justify-content-center d-flex flex-column"
                >
                  {/* <img
                    src={printPI.prepared_by_name_signature}
                    className="signature-size"
                    alt=""
                  /> */}
                  <p className="print-data underline-border text-center">
                    {printPI.approved_by}
                  </p>
                  <p className="print-data text-center mt-2">
                    Noted by (Receiver)
                  </p>
                </Col>
              </Row>
              {/* <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  {printPI.approved_by_name}
                  <span className="receive-by-name">&nbsp;</span>
                  <div className="margin-underline"></div>
                  Received by
                </Row>
              </Col> */}
            </div>
            {/* <div className="print-signatures">
              <span className="text-center text-uppercase print-label fw-bold">
                {printPI.prepared_by}
              </span>
            </div>
            <div className="print-signatories pb-4 mb-4">
              <span>Received by</span>
            </div> */}
          </div>
        </div>
        <div className="mt-4 noPrint mx-3">
          <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
          <Row className="">
            {fileList &&
              fileList.map((attachment) => (
                <Col
                  xs={1}
                  onClick={() => {
                    setPreviewFile(attachment.file_url)
                    setPreview(true)
                  }}
                  className="cursor-pointer preview-container"
                >
                  <img src={attachment.file_url} className="img-preview" />
                </Col>
              ))}
            {!fileList ||
              (fileList.length === 0 && (
                <Col xs={1}>
                  <div className="no-data-cont d-flex justify-content-left preview-container">
                    <img
                      src={noDataImg}
                      alt="no data found"
                      className="img-preview"
                    />
                  </div>
                </Col>
              ))}
          </Row>
        </div>
        <div className=" mt-3">
          <div className="tab-content">
            <h5 className="PI-payment-info mt-3 ms-3">PAYMENT INFO</h5>
            <TablePagination
              tableHeaders={[
                "PMT DATE",
                "TYPE",
                "DETAILS",
                "PMT AMT",
                "AMT APPLIED TO INV",
              ]}
              headerSelector={[
                "payment_date",
                "type",
                "details",
                "grand_total",
                "amount_applied_to_invoice",
              ]}
              tableData={paymentInfo}
            />
          </div>
        </div>

        {/* <Container
          fluid
          className="PI-payment-info-wrapper mt-5 py-3 px-3 edit-form"
        >
          <h5 className="PI-payment-info">PAYMENT INFO</h5>
          <div className="justify-content-center">
            <TablePagination
              tableHeaders={[
                "PMT DATE",
                "TYPE",
                "DETAILS",
                "PMT AMT",
                "AMT APPLIED TO INV",
              ]}
              headerSelector={[
                "payment_date",
                "type",
                "details",
                "amount",
                "amount_applied_to_invoice",
              ]}
              tableData={paymentInfo}
            />
          </div>
        </Container> */}

        {/* footer */}
        <div className="d-flex justify-content-end my-4 pb-5 d-flex-responsive">
          <button
            className="button-secondary me-3"
            onClick={() => navigate("/purchaseinvoices")}
          >
            Close
          </button>
          {printPI.payment_status !== "closed" && (
            <button
              className="button-tertiary me-3"
              onClick={() => navigate("/purchaseinvoices/edit/" + id)}
            >
              Edit
            </button>
          )}
          <button className="button-primary" onClick={handleShowPrintModal}>
            Print
          </button>
        </div>
      </div>
      {/* modals */}
      <PIModal
        show={showPrintModal}
        hide={handleClosePrintModal}
        type="print"
        handler={handlePrintPI}
      />
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewFile}
        />
      </Modal>
      <Footer />
    </div>
  )
}
